import { Pipe, PipeTransform } from '@angular/core';
import { ProgramGroup } from './data/program-group.data';
@Pipe({
  name: 'programGroupFilter'
})
export class ProgramGroupFilterPipe implements PipeTransform {
  transform(items: any[], programGroup: ProgramGroup): any[] {
    if (!items) { return []; }
    if (!programGroup) { return items; }
    return items.filter( it => {
      return it.programGroupId === programGroup.id;
    });
   }
}
